<div class="d-flex flex-row">
  <div class="p-content d-flex flex-column w-100" style="padding-top: 25px;">
    <h2 style="text-align: center;">{{ data.productName }} | Loja: {{ data.competitorName }}</h2>
    <!-- <button class="comparator-button" (click)="closeModal()">Fechar</button> -->
    <form #editForm="ngForm" (ngSubmit)="saveChanges()" style="margin-top: 15px; margin-bottom: 25px;" class="template-content">
      <div class="w-100 d-flex flex-column justify-content-start" style="margin-bottom: 25px;">
        <p>Nome Pesquisado</p>
        <mat-form-field>
          <input matInput name="searchedName" [(ngModel)]="searchedName">
        </mat-form-field>
      </div>
      <div style="margin-top: 25px; margin-bottom: 25px; display: flex; justify-content: space-between;">
        <div>
          <p>Continuar a pesquisar</p>
          <mat-radio-group [(ngModel)]="searchAgainOption" name="searchAgain">
            <mat-radio-button [value]="true">Pesquisar</mat-radio-button>
            <mat-radio-button [value]="false">Não Pesquisar</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <p>Mostrar dados</p>
          <mat-radio-group [(ngModel)]="showDataOption" name="showData">
            <mat-radio-button [value]="true">Mostrar</mat-radio-button>
            <mat-radio-button [value]="false">Ocultar</mat-radio-button>
          </mat-radio-group>
        </div>
        <button class="submit-button" type="submit" style="margin-top: 25px;">
          Guardar
          <mat-icon class="check-icon">check</mat-icon>
        </button>
      </div>
    </form>
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <div class="w-100 d-flex flex-column justify-content-start">
          <table>
            <thead>
              <tr style="border-radius: 10px !important; text-align: left;">
                <th>ID</th>
                <th>Data</th>
                <th>Preço Antigo</th>
                <th>Preço Atualizado</th>
              </tr>
            </thead>
            <tbody>
              @for (productLog of productLogsDisplay; track productLog; let i = $index) {
                <tr>
                  <td>{{productLog.idLog}}</td>
                  <td>{{productLog.timestamp | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                  <td>
                    @if (productLog.oldData.PrecoConcorrente) {
                      {{productLog.oldData.PrecoConcorrente}}€
                    }
                    @if (!productLog.oldData.PrecoConcorrente) {
                    }
                  </td>
                  <td>
                    @if (productLog.newData.PrecoConcorrente) {
                      {{productLog.newData.PrecoConcorrente}}€
                    }
                    @if (!productLog.newData.PrecoConcorrente) {
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

  </div>
</div>